import { render, staticRenderFns } from "./vehicleLicenseAction.vue?vue&type=template&id=289c8da8&scoped=true"
import script from "./vehicleLicenseAction.vue?vue&type=script&lang=js"
export * from "./vehicleLicenseAction.vue?vue&type=script&lang=js"
import style0 from "./vehicleLicenseAction.vue?vue&type=style&index=0&id=289c8da8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289c8da8",
  null
  
)

export default component.exports